<template>
    <CAchievementBox>
        <template #icon>
            <CIcon name="school" />
        </template>

        <template #title>
            {{ title }}
        </template>

        <template #year>
            {{ duration }}
        </template>

        <template #subtitle>
            {{ address }}
        </template>

        <template v-if="item.description || item.desc" #description>
            <span v-html="item.description || item.desc" />
        </template>
    </CAchievementBox>
</template>

<script setup lang="ts">
import type { School } from '#shared/types/User'
import { computed } from 'vue'
import dayjs from 'dayjs'

const props = defineProps<{
    item: School
    secondary?: boolean
}>()

const title = computed(() => {
    if (props.secondary) {
        return props.item.school || ''
    }

    // Use new field format, fallback to legacy specialistation
    const fieldInfo = props.item.field || props.item.specialistation || props.item.level || ''
    return [props.item.degree, fieldInfo].filter(Boolean).join(', ')
})

const duration = computed(() => {
    // Handle new date format (Timestamp objects) or legacy year format
    let startDisplay: string
    let endDisplay: string
    
    if (props.item.startDate) {
        // Handle Timestamp, Date, or string formats
        if (typeof props.item.startDate === 'object' && 'seconds' in props.item.startDate) {
            // Firebase Timestamp format
            startDisplay = dayjs(props.item.startDate.seconds * 1000).format('MM/YYYY')
        } else {
            // Date or string format
            startDisplay = dayjs(props.item.startDate).format('MM/YYYY')
        }
    } else if (props.item.startYear) {
        // Legacy year format
        startDisplay = props.item.startYear.toString()
    } else {
        startDisplay = ''
    }
    
    if (props.item.endDate) {
        // Handle Timestamp, Date, or string formats
        if (typeof props.item.endDate === 'object' && 'seconds' in props.item.endDate) {
            // Firebase Timestamp format
            endDisplay = dayjs(props.item.endDate.seconds * 1000).format('MM/YYYY')
        } else {
            // Date or string format
            endDisplay = dayjs(props.item.endDate).format('MM/YYYY')
        }
    } else if (props.item.endYear && props.item.endYear !== 0) {
        // Legacy year format
        endDisplay = props.item.endYear.toString()
    } else {
        endDisplay = 'súčasnosť'
    }
    
    return [startDisplay, endDisplay].filter(Boolean).join(' – ')
})

const address = computed(() => {
    return [props.secondary ? '' : props.item.school, props.item.address].filter(Boolean).join(', ')
})
</script>